module.exports = __webpack_public_path__ + "img/Appsflyer.148649c1.svg";